import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, delay, map, retry, tap } from 'rxjs/operators';
import { AuthServiceService } from './auth-service.service';
import { Observable, of, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SettingService {
  // _liveApiUrl: any = this.authService._liveApiUrl;
     get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  constructor(private route: ActivatedRoute,
    private http: HttpClient,
    public authService: AuthServiceService) { }

    getSetting(): Observable<any> {
      return this.http.get<any>(`${this._liveApiUrl}/notification/notification-settings/`)
        .pipe(
          catchError(error => {
            // Send the error response to the resultCodeError method
            return throwError(error); // Re-throw the error to preserve the Observable stream
          })
        );
    }
    getDepartureTime(): Observable<any> {
      return this.http.get<any>(`${this._liveApiUrl}/company/company-orders-timing/`)
        .pipe(
          tap(response => {
            // Send the successful response to the resultCodeError method
          //  this.authService.resultCodeError(response);
          }),
          catchError(error => {
            // Send the error response to the resultCodeError method
            return throwError(error); // Re-throw the error to preserve the Observable stream
          })
        );
    }
    emailgetSetting(): Observable<any> {
      const companyId = localStorage.getItem('org_Id'); // Get company_id from localStorage
      if (companyId) {
        return this.http.get<any>(`${this._liveApiUrl}/notification/get-email-notification-setting/${companyId}`);
      } else {
        // Handle the case when companyId is not available
        // For example, you might return an error or empty observable
        return of(null); // or throwError('Company ID not found');
      }
    }
    smsgetSetting(): Observable<any>{
      const companyId = localStorage.getItem('org_Id'); // Get company_id from localStorage
      if (companyId) {
        return this.http .get<any>(`${this._liveApiUrl}/notification/get-sms-notification-setting/${companyId}`)   
      }
      else {
        // Handle the case when companyId is not available
        // For example, you might return an error or empty observable
        return of(null); // or throwError('Company ID not found');
      }
    }
    arkiverGetSetting(): Observable<any>{
      return this.http .get<any>(`${this._liveApiUrl}/company/archive-order-setting/`)
    }
    addSetting(data: any){
      return this.http
      .post<any>(`${this._liveApiUrl}/notification/notification-settings/`, data)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
    }
    updateDepartureTime(formData: FormData): Observable<any> {
      return this.http
        .put<any>(`${this._liveApiUrl}/company/company-orders-timing/`, formData) // Send FormData to the backend
        .pipe(
          map((response: any) => {
            return response; // You can modify this to handle or transform the response if needed
          }),
          catchError(this.authService.handleError) // Handle errors using the authService
        );
    }
    postDepartureTime(formData: FormData): Observable<any> {
      return this.http
        .post<any>(`${this._liveApiUrl}/company/company-orders-timing/`, formData) // Send FormData to the backend
        .pipe(
          map((response: any) => {
            return response; // You can modify this to handle or transform the response if needed
          }),
          catchError(this.authService.handleError) // Handle errors using the authService
        );
    }
    arkiverAddSetting(data: any){
      return this.http
      .post<any>(`${this._liveApiUrl}/company/archive-order-setting/`, data)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
    }
    settingEdit( data: any) {
      return this.http
        .put<any>(`${this._liveApiUrl}/notification/notification-settings/`, data)
        .pipe(
          map((data) => {
            return data;
          }),
          catchError(this.authService.handleError)
        );
    }
    emailsettingEdit( data: any) {
      return this.http
        .put<any>(`${this._liveApiUrl}/notification/email-notification-setting/`, data)
        .pipe(
          map((data) => {
            return data;
          }),
          catchError(this.authService.handleError)
        );
    }
    smssettingEdit( data: any) {
      return this.http
        .put<any>(`${this._liveApiUrl}/notification/sms-notification-setting/`, data)
        .pipe(
          map((data) => {
            return data;
          }),
          catchError(this.authService.handleError)
        );
    }
    adminsettingupdate(id: number, formData: FormData) {
      return this.http
        .put<any>(`${this._liveApiUrl}/notification/grant-permissions-to-admins/${id}`, formData)
        .pipe(
          map((responseData) => {
            return responseData;
          }),
          catchError(this.authService.handleError)
        );
    }    
    
    archivesettingEdit( data: any) {
      return this.http
        .put<any>(`${this._liveApiUrl}/company/archive-order-setting/`, data)
        .pipe(
          map((data) => {
            return data;
          }),
          catchError(this.authService.handleError)
        );
    }
  
}
